import React from 'react';

export default props => (
  <svg
    {...props}
    viewBox="0 0 150 150"
    width={150}
    height={150}
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
  >
    <style>
      {
        "#e4phBJoNfvq9 {animation-name: e4phBJoNfvq9__m, e4phBJoNfvq9_c_o;animation-duration: 6000ms;animation-fill-mode: forwards;animation-timing-function: linear;animation-direction: normal;animation-iteration-count: infinite;}@keyframes e4phBJoNfvq9__m { 0% {d: path('M93.86,26.5L93.85,26.67L93.91,20.13L93.86,20.13L93.86,26.5Z')} 5% {d: path('M93.86,26.5L93.85,26.67L93.91,20.13L93.86,20.13L93.86,26.5Z');animation-timing-function: cubic-bezier(1,0,0,1)} 13.333333% {d: path('M93.86,26.5L114.14,14.82L114.2,8.28L93.86,20.13L93.86,26.5Z');animation-timing-function: cubic-bezier(1,0,0,1)} 21.666667% {d: path('M114.200001,14.82L114.14,14.82L114.2,8.28L114.200001,8.45L114.200001,14.82Z');animation-timing-function: cubic-bezier(1,0,0,1)} 26.666667% {d: path('M114.200001,14.82L114.14,14.82L114.2,8.28L114.200001,8.45L114.200001,14.82Z');animation-timing-function: cubic-bezier(1,0,0,1)} 35% {d: path('M93.86,26.5L93.85,26.67L93.91,20.13L93.86,20.13L93.86,26.5Z');animation-timing-function: cubic-bezier(1,0,0,1)} 40% {d: path('M93.86,26.5L93.85,26.67L93.91,20.13L93.86,20.13L93.86,26.5Z');animation-timing-function: cubic-bezier(1,0,0,1)} 48.333333% {d: path('M93.86,26.5L114.14,14.82L114.2,8.28L93.86,20.13L93.86,26.5Z');animation-timing-function: cubic-bezier(1,0,0,1)} 56.666667% {d: path('M114.200001,14.82L114.14,14.82L114.2,8.28L114.200001,8.45L114.200001,14.82Z');animation-timing-function: cubic-bezier(1,0,0,1)} 61.666667% {d: path('M114.200001,14.82L114.14,14.82L114.2,8.28L114.200001,8.45L114.200001,14.82Z');animation-timing-function: cubic-bezier(1,0,0,1)} 70% {d: path('M93.86,26.5L93.85,26.67L93.91,20.13L93.86,20.13L93.86,26.5Z');animation-timing-function: cubic-bezier(1,0,0,1)} 75% {d: path('M93.86,26.5L93.85,26.67L93.91,20.13L93.86,20.13L93.86,26.5Z');animation-timing-function: cubic-bezier(1,0,0,1)} 83.333333% {d: path('M93.86,26.5L114.14,14.82L114.2,8.28L93.86,20.13L93.86,26.5Z');animation-timing-function: cubic-bezier(1,0,0,1)} 91.666667% {d: path('M114.200001,14.82L114.14,14.82L114.2,8.28L114.200001,8.45L114.200001,14.82Z')} 100% {d: path('M114.200001,14.82L114.14,14.82L114.2,8.28L114.200001,8.45L114.200001,14.82Z')}}@keyframes e4phBJoNfvq9_c_o { 0% {opacity: 0;animation-timing-function: cubic-bezier(1,0,0,1)} 5% {opacity: 1;animation-timing-function: cubic-bezier(1,0,0,1)} 21.666667% {opacity: 1;animation-timing-function: cubic-bezier(1,0,0,1)} 26.666667% {opacity: 0;animation-timing-function: cubic-bezier(1,0,0,1)} 35% {opacity: 0;animation-timing-function: cubic-bezier(1,0,0,1)} 40% {opacity: 1;animation-timing-function: cubic-bezier(1,0,0,1)} 56.666667% {opacity: 1;animation-timing-function: cubic-bezier(1,0,0,1)} 61.666667% {opacity: 0;animation-timing-function: cubic-bezier(1,0,0,1)} 70% {opacity: 0;animation-timing-function: cubic-bezier(1,0,0,1)} 75% {opacity: 1;animation-timing-function: cubic-bezier(1,0,0,1)} 83.333333% {opacity: 1;animation-timing-function: cubic-bezier(1,0,0,1)} 91.666667% {opacity: 1;animation-timing-function: cubic-bezier(1,0,0,1)} 96.666667% {opacity: 0} 100% {opacity: 0}} #e4phBJoNfvq10_to {animation: e4phBJoNfvq10_to__to 6000ms linear infinite normal forwards}@keyframes e4phBJoNfvq10_to__to { 0% {transform: translate(41.255px,34px);animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 21.666667% {transform: translate(41.255px,42px);animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 46.666667% {transform: translate(41.255px,34px);animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 75% {transform: translate(41.255px,42px);animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 100% {transform: translate(41.255px,34px)}} #e4phBJoNfvq19_to {animation: e4phBJoNfvq19_to__to 6000ms linear infinite normal forwards}@keyframes e4phBJoNfvq19_to__to { 0% {transform: translate(99.568638px,80.213669px);animation-timing-function: cubic-bezier(0.785,0.135,0.15,0.86)} 15% {transform: translate(74.096829px,62.863566px);animation-timing-function: cubic-bezier(0.785,0.135,0.15,0.86)} 36.666667% {transform: translate(74.09683px,82.245141px);animation-timing-function: cubic-bezier(0.785,0.135,0.15,0.86)} 56.666667% {transform: translate(56.716829px,97.60367px);animation-timing-function: cubic-bezier(0.785,0.135,0.15,0.86)} 80% {transform: translate(70.726216px,102.033462px);animation-timing-function: cubic-bezier(0.785,0.135,0.15,0.86)} 100% {transform: translate(99.568638px,80.213669px)}} #e4phBJoNfvq32_to {animation: e4phBJoNfvq32_to__to 6000ms linear infinite normal forwards}@keyframes e4phBJoNfvq32_to__to { 0% {transform: translate(0px,0px);animation-timing-function: cubic-bezier(0.785,0.135,0.15,0.86)} 15% {transform: translate(-25.471809px,-17.350103px);animation-timing-function: cubic-bezier(0.785,0.135,0.15,0.86)} 36.666667% {transform: translate(-25.471808px,2.031469px);animation-timing-function: cubic-bezier(0.785,0.135,0.15,0.86)} 56.666667% {transform: translate(-42.851809px,17.39px);animation-timing-function: cubic-bezier(0.785,0.135,0.15,0.86)} 80% {transform: translate(-28.630284px,21.733702px);animation-timing-function: cubic-bezier(0.785,0.135,0.15,0.86)} 99.833333% {transform: translate(0px,0px)} 100% {transform: translate(0px,0px)}} #e4phBJoNfvq34_to {animation: e4phBJoNfvq34_to__to 6000ms linear infinite normal forwards}@keyframes e4phBJoNfvq34_to__to { 0% {transform: translate(110.878471px,64.201899px);animation-timing-function: cubic-bezier(0.785,0.135,0.15,0.86)} 15% {transform: translate(85.406662px,46.851796px);animation-timing-function: cubic-bezier(0.785,0.135,0.15,0.86)} 36.666667% {transform: translate(85.406663px,66.233368px);animation-timing-function: cubic-bezier(0.785,0.135,0.15,0.86)} 56.666667% {transform: translate(68.026662px,81.591899px);animation-timing-function: cubic-bezier(0.785,0.135,0.15,0.86)} 80% {transform: translate(82.036049px,86.021691px);animation-timing-function: cubic-bezier(0.785,0.135,0.15,0.86)} 100% {transform: translate(110.878471px,64.201899px)}}"
      }
    </style>
    <rect width="150" height="150" rx="0" ry="0" fill="none" strokeWidth="0" />
    <path
      d="M34.96,108.9L61.14,93.76l.08-27.23L34.96,81.88v27.02Z"
      fill="none"
      stroke="#000"
      strokeWidth="0.5"
      strokeLinejoin="round"
    />
    <path
      d="M7,103.48L75.3,64.12l68.55,39.5-68.3,39.36L7,103.48Z"
      fill="none"
      stroke="#000"
      strokeWidth="0.5"
      strokeLinejoin="round"
    />
    <path
      d="M7.22,109.73L75.36,70.46l68.58,39.52L75.8,149.25L7.22,109.73Z"
      fill="none"
      stroke="#000"
      strokeWidth="0.5"
      strokeLinejoin="round"
      strokeDasharray="0,0,6.67,6.67"
    />
    <path
      d="M48.17,117.37L101.39,86.8L101.56,0L48.17,31v86.37Z"
      fill="#fff"
      stroke="#000"
      strokeWidth="0.5"
      strokeLinejoin="round"
      strokeDasharray="0,0,6.67,6.67"
    />
    <path
      d="M75.66,65.38v-2.53c0-1.11.13-2.17.38-3.18s.68-2.1,1.28-3.27c.61-1.17,1.44-2.52,2.49-4.04c1.04-1.52,1.85-2.84,2.44-3.94.6-1.13,1.02-2.14,1.27-3.04.25-.92.38-1.81.38-2.68c0-1.53-.31-2.69-.92-3.48-.61-.81-1.44-1.21-2.5-1.22-1.05,0-2.23.4-3.54,1.22-1.38.87-2.62,2.03-3.71,3.48-1.08,1.43-1.93,2.99-2.56,4.69-.62,1.68-.93,3.34-.93,4.98l-.98.62c0-1.85.36-3.74,1.07-5.66s1.68-3.69,2.91-5.32c1.25-1.64,2.64-2.95,4.2-3.93c1.5-.94,2.84-1.4,4.03-1.37c1.2.02,2.15.5,2.85,1.41.7.9,1.05,2.23,1.05,3.98c0,1.01-.14,2.04-.44,3.1-.28,1.03-.76,2.18-1.42,3.42-.66,1.25-1.54,2.7-2.65,4.35-.97,1.44-1.73,2.68-2.28,3.71-.53,1.01-.91,1.96-1.12,2.83-.22.86-.32,1.77-.32,2.75v2.53l-.98.62v-.03Zm.49,10.89c-.31.19-.57.23-.78.11s-.32-.36-.32-.72.11-.74.32-1.12c.21-.39.47-.68.78-.87.3-.19.56-.23.78-.11.21.12.32.36.32.72c0,.24-.06.5-.16.76-.09.25-.22.48-.39.7s-.35.4-.55.53Z"
      strokeWidth="0"
    />
    <path
      d="M113.95,102.37l-15.23,8.61l7.79,4.4l15.23-8.61-7.79-4.4Z"
      fill="none"
      stroke="#000"
      strokeWidth="0.5"
      strokeLinejoin="round"
    />
    <path
      id="e4phBJoNfvq9"
      d="M93.86,26.5l-.01.17.06-6.54h-.05v6.37Z"
      opacity="0"
      fill="#f4eee6"
      stroke="#000"
      strokeWidth="0.5"
      strokeLinejoin="round"
    />
    <g id="e4phBJoNfvq10_to" transform="translate(41.255,34)">
      <g transform="translate(-41.254999,-37.089999)">
        <path
          d="M26.81,61.7L58.46,43.44l.11-29.21L26.81,32.74v28.96Z"
          fill="#fff"
          stroke="#000"
          strokeWidth="0.5"
          strokeLinejoin="round"
        />
        <path
          d="M26.81,61.7l-2.87-1.74v-28.94l2.87,1.73v28.96v0-.01Z"
          fill="#f4eee6"
          stroke="#000"
          strokeWidth="0.5"
          strokeLinejoin="round"
        />
        <path
          d="M26.81,32.74l-2.74-1.76L55.83,12.47l2.74,1.76L26.81,32.74Z"
          fill="#fff"
          stroke="#000"
          strokeWidth="0.5"
          strokeLinejoin="round"
        />
        <path d="M53.95,39.93L32.69,52.16l-.03-16.07L53.92,23.86l.03,16.07Z" fill="#f4eee6" strokeWidth="0" />
        <g>
          <path
            d="M37.55,39.18c.9-.84,1.85-.57,2.13.59s-.21,2.78-1.11,3.62-1.86.57-2.14-.6.22-2.78,1.12-3.62v0v.01Z"
            fill="#fcf9f4"
            strokeWidth="0"
          />
          <path
            d="M42.98,35.93c.9-.84,1.86-.57,2.14.59s-.22,2.78-1.12,3.62-1.85.57-2.13-.59c-.28-1.17.21-2.78,1.11-3.62Z"
            fill="#fcf9f4"
            strokeWidth="0"
          />
          <path
            d="M48.4,32.85c.9-.84,1.86-.57,2.14.6.28,1.16-.21,2.78-1.11,3.62s-1.86.57-2.14-.59c-.28-1.17.21-2.78,1.11-3.62v0-.01Z"
            fill="#fcf9f4"
            strokeWidth="0"
          />
        </g>
      </g>
    </g>
    <g id="e4phBJoNfvq19_to" transform="translate(99.568638,80.213669)">
      <g transform="translate(-99.568638,-80.213668)">
        <path
          d="M94,54.96c-4.49,7.98-6.97,16.11-7.32,22.83-.35,6.7,1.41,12.06,5.49,14.36c3.68,2.07,6.91,2.82,9.82,2.5s5.48-1.71,7.84-3.85c4.51-4.08,8.37-10.92,12.61-18.45.19-.34.38-.69.58-1.03.46-.82.91-1.63,1.37-2.43c1.75-3.08,3.42-6.04,4.84-8.85c1.78-3.54,3.17-6.87,3.81-9.98.63-3.11.51-6.02-.75-8.69-.79-1.69-2.04-3.28-3.82-4.77-1.03-.86-2.23-1.68-3.63-2.46-4.07-2.29-9.58-1.02-15.11,2.75C104.16,40.67,98.49,47,94,54.98v-.02Z"
          fill="#f4eee6"
          stroke="#000"
          strokeWidth="0.5"
          strokeLinejoin="round"
        />
        <path
          d="M97.22,56.78c-4.49,7.98-6.97,16.11-7.32,22.83-.35,6.7,1.41,12.06,5.49,14.35c4.07,2.3,9.57,1.02,15.11-2.75c5.56-3.78,11.24-10.11,15.73-18.08c4.48-7.98,6.96-16.11,7.31-22.83.35-6.7-1.4-12.06-5.48-14.36-4.07-2.29-9.58-1.02-15.11,2.75-5.57,3.78-11.24,10.11-15.73,18.09Z"
          fill="#fff"
          stroke="#000"
          strokeWidth="0.5"
          strokeLinejoin="round"
        />
        <path
          d="M100.44,58.59c-3.69,6.55-5.81,13.19-6.24,18.62-.43,5.42.81,9.74,3.97,11.52s7.51.6,11.92-2.57c4.42-3.19,9-8.43,12.69-14.98s5.81-13.19,6.24-18.62c.43-5.42-.81-9.74-3.97-11.52s-7.51-.6-11.92,2.57c-4.42,3.19-9,8.43-12.69,14.98Z"
          fill="#f4eee6"
          stroke="#000"
          strokeWidth="0.5"
          strokeLinejoin="round"
        />
        <path
          d="M65.97,120.77L88.29,90.36c.4-.73,1.18-1.07,2.05-1.08.88-.01,1.9.31,2.86.96.95.65,1.68,1.51,2.08,2.39s.48,1.8.08,2.54l-.13.27v.02l-.02.02-21.32,30.47-.12.18-.19-.12-7.54-4.82-.25-.16.17-.23v-.03h.01Z"
          fill="#f4eee6"
          stroke="#000"
          strokeWidth="0.5"
          strokeLinejoin="round"
        />
        <path
          d="M100.57,58.36c-3.87,6.87-5.8,13.62-6.28,18.92-.24,2.65-.13,4.95.29,6.72.41,1.76,1.13,3.07,2.15,3.64c3.17,1.79,7.47.74,11.83-2.32c4.37-3.07,8.9-8.2,12.59-14.76c3.69-6.55,5.86-13.16,6.34-18.58.48-5.39-.72-9.7-3.89-11.49-1.36-.76-3.06-.77-4.92-.19s-3.91,1.76-6.02,3.4c-4.2,3.29-8.62,8.47-12.09,14.64v.02Z"
          fill="#fff"
          stroke="#000"
          strokeWidth="0.5"
          strokeLinejoin="round"
        />
        <path
          d="M71.26,120.89c1.07.72,1.89,1.67,2.35,2.64.46.96.57,1.97.14,2.76-.42.79-1.28,1.15-2.25,1.14-.98-.01-2.11-.39-3.18-1.11s-1.89-1.67-2.35-2.64c-.46-.96-.58-1.97-.15-2.76s1.28-1.15,2.26-1.14c.97.01,2.11.38,3.18,1.11Z"
          fill="#f4eee6"
          stroke="#000"
          strokeWidth="0.5"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <g mask="url(#e4phBJoNfvq31)">
      <g>
        <g>
          <path
            d="M58.18,106.67L111.4,76.1l.17-86.8-53.39,31v86.37Z"
            fill="#fff"
            stroke="#000"
            strokeWidth="0.5"
            strokeLinejoin="round"
          />
          <path
            d="M85.67,54.68v-2.53c0-1.11.13-2.17.38-3.18s.68-2.1,1.28-3.27c.61-1.17,1.44-2.52,2.49-4.04c1.04-1.52,1.85-2.84,2.44-3.94.6-1.13,1.02-2.14,1.27-3.04.25-.92.38-1.81.38-2.68c0-1.53-.31-2.69-.92-3.48-.61-.81-1.44-1.21-2.5-1.22-1.05,0-2.23.4-3.54,1.22-1.38.87-2.62,2.03-3.71,3.48-1.08,1.43-1.93,2.99-2.56,4.69-.62,1.68-.93,3.34-.93,4.98l-.98.62c0-1.85.36-3.74,1.07-5.66s1.68-3.69,2.91-5.32c1.25-1.64,2.64-2.95,4.2-3.93c1.5-.94,2.84-1.4,4.03-1.37c1.2.02,2.15.5,2.85,1.41.7.9,1.05,2.23,1.05,3.98c0,1.01-.14,2.04-.44,3.1-.28,1.03-.76,2.18-1.42,3.42-.66,1.25-1.54,2.7-2.65,4.35-.97,1.44-1.73,2.68-2.28,3.71-.53,1.01-.91,1.96-1.12,2.83-.22.86-.32,1.77-.32,2.75v2.53l-.98.62v-.03Zm.49,10.89c-.31.19-.57.23-.78.11s-.32-.36-.32-.72.11-.74.32-1.12c.21-.39.47-.68.78-.87.3-.19.56-.23.78-.11.21.12.32.36.32.72c0,.24-.06.5-.16.76-.09.25-.22.48-.39.7s-.35.4-.55.53Z"
            strokeWidth="0"
          />
        </g>
      </g>
      <mask id="e4phBJoNfvq31">
        <g id="e4phBJoNfvq32_to" transform="translate(0,0)">
          <g transform="translate(0,0)">
            <path
              d="M100.57,58.36c-3.87,6.87-5.8,13.62-6.28,18.92-.24,2.65-.13,4.95.29,6.72.41,1.76,1.13,3.07,2.15,3.64c3.17,1.79,7.47.74,11.83-2.32c4.37-3.07,8.9-8.2,12.59-14.76c3.69-6.55,5.86-13.16,6.34-18.58.48-5.39-.72-9.7-3.89-11.49-1.36-.76-3.06-.77-4.92-.19s-3.91,1.76-6.02,3.4c-4.2,3.29-8.62,8.47-12.09,14.64v.02Z"
              fill="#fff"
              strokeWidth="0"
            />
          </g>
        </g>
      </mask>
    </g>
    <g id="e4phBJoNfvq34_to" transform="translate(110.878471,64.201899)">
      <path
        d="M100.57,58.36c-3.87,6.87-5.8,13.62-6.28,18.92-.24,2.65-.13,4.95.29,6.72.41,1.76,1.13,3.07,2.15,3.64c3.17,1.79,7.47.74,11.83-2.32c4.37-3.07,8.9-8.2,12.59-14.76c3.69-6.55,5.86-13.16,6.34-18.58.48-5.39-.72-9.7-3.89-11.49-1.36-.76-3.06-.77-4.92-.19s-3.91,1.76-6.02,3.4c-4.2,3.29-8.62,8.47-12.09,14.64v.02Z"
        transform="translate(-110.878471,-64.201899)"
        fill="#cce0ea"
        fill-opacity="0.25"
        stroke="#000"
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
